import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import Content from "./Content";
import {
  inputFomatAlias,
  billPlease,
  inputFormat,
  getDefaultOriginPlace,
  countDishes,
  getMyLocation,
  calculateCODFee,
  getMyRegion,
  getOS,
  moneyFormat
} from "../../ultil";
import { PRODUCT_SERVICE } from "../../clientConfig";
import axios from "axios";
// import {
//   placeAutocomplete,
//   getLocationName,
// } from '../../clientServices/order'
import { connect } from "react-redux";
import Login from "../login/Login";
import Swal from "sweetalert2";
import {
  getInfoStore,
  getListProduct,
  getListProductType,
  createOrderStore,
  getOrderType,
  getConfigErrandFee,
  getDistanceMoney,
  getOrderTypeFood,
  getConfigCODOrder,
  placeAutocomplete,
  getListForCustomer,
  getForCustomer,
  getTimeLine,
  rejectForCustomer,
  getConfigPromoteStore,
  getListPromoteShop,
  getCountPromoteShop,
  getPromoteShop,
  checkOutOfStock,
  getConfigShowContact
} from "../../clientServices/previewStore";
import { getTimeLineOrder } from "../../store/action/storeOrderRedux";
import PlaceAutoCompleteInput from "../../components/others/PlaceAutoCompleteInput";
import {
  promoteList,
  promoteGet,
  promoteCount,
  getPromoteCodebyID
} from "../../clientServices/promote";
import { Logout } from "../../clientServices/logout";
import toastr from "toastr";
import socket from "../../socket/socket-shop";
import { getUserInf } from "../../store/action/userAction";
import { setGlobalVariable } from "../../store/action/globalVariableAction";
import Cart from "../../components/StoreCart/Cart";
import { trackingActionIntervel } from "../../clientServices/app";
import Modal from "react-modal";
import withReactContent from "sweetalert2-react-content";
import { modalStyle, modalStyleCenter, style, modalStyleDetail, modalStyleBottom } from "../../style";
import Loading from "../../components/Loading";
import AccountUser from "../../components/StoreCart/AccountUser";
import ListOrder from "../../components/StoreCart/ListOrder";
import DetailOrder from "../../components/StoreCart/DetailOrder";
import Countdown from "../../components/others/countdown";
import TextBody from "../../components/Text/TextBody";
import TextHead from "../../components/Text/TextHead";
import TextBody2 from "../../components/Text/TextBody2";
import TextTitle1 from "../../components/Text/TextTitle1";
import InputCustom from "../../components/Input/InputCustom";

import {
  AppBar,
  Badge,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  ButtonBase,
  Button,
  ButtonGroup,
  Container,
  Drawer,
  Divider,
  Paper,
  IconButton,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tab,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  Slide
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PersonIcon from '@mui/icons-material/Person';
import ForumIcon from '@mui/icons-material/Forum';
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
let interval = setInterval(() => {}, 10);

const ReactSwal = withReactContent(Swal);
let delay = setTimeout(function() {}, 300);
const routes = [
  {
    title: 'Cửa hàng',
    icon: <i className="icon-shop" style={{fontSize: '20px'}}/>,
    value: 0
  },
  {
    title: 'Đơn hàng',
    icon: <i className="icon-receipt-1" style={{fontSize: '20px'}}/>,
    value: 3
  },
  // {
  //   title: 'Chat',
  //   icon: <i className="icon-messages-2" style={{fontSize: '20px'}}/>
  // },
  {
    title: 'Tài khoản',
    icon: <i className="icon-user" style={{fontSize: '20px'}}/>,
    value: 2
  },

]

const BtnMenu = ({onClick, value, index, icon, title}) => {
  const active = value === index
  return <ButtonBase onClick={()=>onClick(value)} sx={{flex: 1, flexDirection: 'column', padding: '12px', color: active ? '#1589D8' :'#929394'}}>
    <Box>{icon}</Box>
    <TextBody2 color={active ? '#1589D8' :'#929394'}>{title}</TextBody2>
  </ButtonBase>
}

const PreviewStore = props => {
  const [limit, setLimit] = useState(10);
  const [limitOrder, setLimitOrder] = useState(10);
  const [displayStore, setDisplayStore] = useState(false);
  const [isStore, setIsStore] = useState(false);
  const [discountMoney, setDiscountMoney] = useState(0);
  const [infoStore, setInfoStore] = useState({});
  const [listStore, setListStore] = useState([]);
  const [productType, setProductType] = useState("");
  const [listFiter, setListFiter] = useState([]);
  const [dataDetail, setDataDetail] = useState({});
  const [addCart, setAddCart] = useState([]);
  const [isLogin, setIsLogin] = useState(false);
  const [isCart, setIsCart] = useState(0);
  const [grid, setGrid] = useState(2);
  const [nameAddressUser, setNameAddressUser] = useState("");
  const [location, setLocation] = useState({});
  const [distanceMoney, setDistanceMoney] = useState({});
  const [orderType, setOrderType] = useState({});
  const [configErrandFee, setConfigErrandFee] = useState({});
  const [note, setNote] = useState("");
  const [tip, setTip] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAddress, setIsOpenAddress] = useState(false);
  const [promoteCode, setPromoteCode] = useState("");
  const [promoteId, setPromoteId] = useState("");
  const [listPromote, setListPromote] = useState([]);
  const [configCOD, setConfigCOD] = useState();
  const [count, setCount] = useState();
  const [moneyCod, setMoneyCod] = useState(0);
  const [addressInput, setAddressInput] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [listOrderUser, setListOrderUser] = useState([]);
  const [idFiterOrder, setIdFiterOrder] = useState("");
  const [idDetailOrder, setIdDetailOrder] = useState("");
  const [detailOrder, setDetailOrder] = useState({});
  const [timeLine, seTimeLine] = useState([]);
  const [noteStore, setNoteStore] = useState("");
  const [subName, setSubName] = useState("");
  const [platform, setPlatform] = useState(null);
  const [inputSearch, setInputSearch] = useState("");
  const [user, setUser] = useState({});
  const [configPromote, setConfigPromote] = useState(1);
  const [countPromoteStore, setCountPromoteStore] = useState();
  const [isOpenPromoteStore, setIsOpenPromoteStore] = useState(false);
  const [listPromoteStore, setListPromoteStore] = useState([]);
  const [promoteCodeStore, setPromoteCodeStore] = useState("");
  const [promoteIdStore, setPromoteIdStore] = useState("");
  const [discountMoneyStore, setDiscountMoneyStore] = useState(0);
  const [isOpenLogin, setIsOpenLogin] = useState(false);
  const [messagePopup, setMessagePopup] = useState("");
  const [isOpenApp, setIsOpenApp] = useState(false);
  const [nameStore, setNameStore] = useState("");
  const [configContact, setConfigContact] = useState({});
  const [isChekIsAvailable, setIsChekIsAvailable] = useState(true);
  const [namePromoteCodeStore, setNamePromoteCodeStore] = useState("");
  const [namePromoteCode, setNamePromoteCode] = useState("");

  const [modalIsOpenTopping, setIsOpenTopping] = useState(false);
  const [isEditTopping, setIsEditTopping] = useState(false);
  const [indexEditTopping, setIndexEditTopping] = useState(0);
  const [isEditToppingInCart, setIsEditToppingInCart] = useState(false);
  const [isAddPromote, setIsAddPromote] = useState(false);

  useEffect(() => {
    const os = getOS();
    if (["iOS", "Android"].includes(os)) {
      setPlatform(os);
    }
    getConfigShowContact({}).then(res => {
      setConfigContact(res.data);
    });
  }, []);
  // let resultsRef = useRef();
  // useEffect(() => {
  //   if (resultsRef.current) {
  //     window.scrollTo({
  //       behavior: "smooth",
  //       top: resultsRef.current.offsetTop
  //     });
  //   }
  // }, [idFiterOrder, isCart, productType]);
  useEffect(() => {
    if (localStorage.getItem("location") != null) {
      const dataLocation = JSON.parse(localStorage.getItem("location"));
      setNameAddressUser(dataLocation.address);
      setLocation({
        lat: dataLocation.geometry.lat,
        lng: dataLocation.geometry.long
      });
    }

    if (
      Object.values(props.user).length != 0 &&
      Object.values(location).length === 0 &&
      displayStore == true
    ) {
      setIsOpenAddress(true);
    }
  }, [props.user]);
  const getListPromote = () => {
    promoteList({
      moneyUng: billPlease(addCart) - discountMoneyStore,
      // service:infoStore.service ,
      store: infoStore._id,
      service: "5d4cea5468731c9493253bb9",
      originPlace: {
        lat: infoStore.location.coordinates[1],
        lng: infoStore.location.coordinates[0]
      },
      destinationPlaces: [
        {
          lat: location.lat,
          lng: location.lng
        }
      ],
      originName: infoStore.address,
      destinationNames: [{ name: nameAddressUser }]
    }).then(res => {
      setListPromote(_.get(res, "data", []));
    });
  };

  const getCount = data => {
    promoteCount({
      store: data._id,
      service: "5d4cea5468731c9493253bb9"
    }).then(res => {
      setCount(_.get(res, "data"));
    });
  };
  useEffect(() => {
    window.visualViewport.addEventListener('resize', ()=> {
      if ('visualViewport' in window) {
      props.setGlobalVariable({
          virturalKeyboard: window.visualViewport.height * window.visualViewport.scale / document.documentElement.clientHeight < 0.85
        });
      }
    });

    window.addEventListener("blur", () => {
      props.setGlobalVariable({
        windowFocus: false
      });
      // if (_.get(socket.getSocket(), "connected", null)) socket.destroy();
    });
    window.addEventListener("focus", () => {
      props.setGlobalVariable({
        windowFocus: true
      });
      // if (!_.get(socket.getSocket(), "connected", null)) socket.init();
    });
    // props.getTimeLineOrder()
    // props.getUserInf();
    // trackingActionIntervel();
  }, []);

  useEffect(() => {
    props.getUserInf();
  }, [props.globalVariable.windowFocus]);

  useEffect(() => {
    if (!_.isEmpty(props.user)) {
      trackingActionIntervel();
    }
  }, [props.user]);

  useEffect(() => {
    if (!_.isEmpty(props.store)) {
      const cartCode = localStorage.getItem("code-store");
      if (cartCode == null) {
        localStorage.setItem("code-store", props.store._id.toUpperCase());
      } else {
        if (cartCode != props.store._id.toUpperCase()) {
          localStorage.setItem("code-store", props.store._id.toUpperCase());
          localStorage.removeItem("list-carts");
          localStorage.removeItem("screen");
        }
        let obj = JSON.parse(localStorage.getItem("list-carts"));
        if (obj != null) {
          setAddCart(_.cloneDeep(obj));
        }
      }
      setDisplayStore(false);
      setIsStore(false);
      if (props.store) {
        // const os = getOS();
        // if (["Android"].includes(os)) {
        //     setIsOpenApp(true)
        // }else{
        //     document.location.href = `sanshipvietnam://tickbox/${props.store.service}/${props.store._id}`
        // }
        localStorage.setItem("my-region", props.store.region);
        setInfoStore(props.store);
        btnGetlistProduct(props.store);
        getListFilter(props.store);
        getCount(props.store);
        setDisplayStore(true);
        setNameStore("");
        getConfigFee();
        getPromoteStoreConfig(props.store);
        const screen = localStorage.getItem("screen");
        if (screen != null) {
          setIsCart(parseInt(screen));
        } else {
          setIsCart(0);
        }
      } else {
        setIsStore(true);
        setDisplayStore(false);
      }
    } else {
      setDisplayStore(false);
      setIsStore(true);
    }
    setIsLoading(false);
  }, [props.store]);
  const closeModalOffAndroid = () => {
    setIsOpenApp(false);
  };
  const getPromoteStoreConfig = dataStore => {
    getConfigPromoteStore({}).then(res => {
      if (_.get(res, "data.isOpen") === 1) {
        getListPromoteStore(dataStore);
        getCountPromoteStore(dataStore);
      }
      setConfigPromote(_.get(res, "data.isOpen"));
    });
  };
  const getListPromoteStore = data => {
    getListPromoteShop({ storeId: data._id }).then(res => {
      setListPromoteStore(res.data);
    });
  };
  const getCountPromoteStore = data => {
    getCountPromoteShop({ storeId: data._id }).then(res => {
      setCountPromoteStore(res.data);
    });
  };
  const openModelPromoteStore = () => {
    if (_.isEmpty(user)) {
      setMessagePopup("Bạn vui lòng đăng nhập để xem khuyến mại của cửa hàng");
      openModelLogin();
    } else {
      setIsOpenPromoteStore(true);
    }
  };
  const closeModalPromote = () => {
    setPromoteCodeStore(promoteCodeStore);
    setIsOpenPromoteStore(false);
  };
  useEffect(() => {
    if (Object.values(props.user).length != 0) {
      GetOrdertype();
      if (infoStore && infoStore.location) {
        getListPromote();
        getPromoteStoreConfig(props.store);
        getCount(props.store);
      }
    }
  }, [props.user]);
  const btnLogout = () => {
    Swal.fire({
      title: "Đăng xuất tài khoản",
      icon: "info",
      showDenyButton: true,
      confirmButtonText: "Có",
      denyButtonText: "Không"
    }).then(result => {
      if (result.value) {
        Logout()
          .then(res => {
            if (res.code == 200) {
              window.location.reload();
            }
          })
          .catch(e => console.log(e));
      } else if (result.dismiss === Swal.DismissReason.deny) {
      }
    });
  };
  const onClickCode = promoteInf => {
    setIsLoading(true);
    getPromoteCodebyID({
      store: infoStore._id,
      id: promoteInf._id,
      originPlace: {
        lat: infoStore.location.coordinates[1],
        lng: infoStore.location.coordinates[0]
      },
      destinationPlaces: [
        {
          lat: location.lat,
          lng: location.lng
        }
      ],
      originName: infoStore.address,
      destinationNames: [{ name: nameAddressUser }]
    })
      .then(res => {
        setIsLoading(false);
        checkPromote(_.get(res, "data.code"));
      })
      .catch(e => setIsLoading(false));
  };
  const onClickCodeStore = promoteInf => {
    checkPromoteCodeStore(promoteInf.code, (err, result) => {
      if (result) {
        toastr.info(
          `Mã ưu đãi áp dụng thành công, bạn được giảm ${result
            .toString()
            .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")}đ vào phí ship!`
        );
        closeModalPromote();
      }
    });
  };
  const checkPromote = code => {
    setIsLoading(true);
    promoteGet({
      store: infoStore._id,
      moneyUng: billPlease(addCart) - discountMoneyStore,
      destinationNames: [infoStore.address],
      destinationPlaces: [
        {
          lat: infoStore.location.coordinates[1],
          lng: infoStore.location.coordinates[0]
        }
      ],

      // service:infoStore.service,
      service: "5d4cea5468731c9493253bb9",
      code: code,
      distance: distanceMoney.distance,
      money: distanceMoney.money,
      orderType: orderType._id,
      originName: nameAddressUser,
      originPlace: {
        lat: location.lat,
        lng: location.lng
      }
    })
      .then(res => {
        setIsLoading(false);
        setIsOpen(false);
        setPromoteCode(code);
        setNamePromoteCode(code);
        setDiscountMoney(_.get(res, "data.discount"));
        setPromoteId(_.get(res, "data.id"));
        !isAddPromote &&
          toastr.success(
            `Bạn được giảm ${inputFormat(
              (_.get(res, "data.discount") / 1000).toString()
            )} khuyến mại giao hàng`
          );
        setIsAddPromote(true);
      })
      .catch(function(e) {
        setNamePromoteCode("");
        setDiscountMoney(0);
        setPromoteCode("");
        setPromoteId("");
        setIsLoading(false);
      });
  };
  const checkPromoteCodeStore = (code, data) => {
    getPromoteShop({
      destinationNames: [infoStore.address],
      destinationPlaces: [
        {
          lat: infoStore.location.coordinates[1],
          lng: infoStore.location.coordinates[0]
        }
      ],

      // service:infoStore.service,
      service: "5d4cea5468731c9493253bb9",
      code: code,
      storeId: infoStore._id,
      distance: distanceMoney.distance,
      money: billPlease(addCart),
      orderType: orderType._id,
      originName: nameAddressUser,
      originPlace: {
        lat: location.lat,
        lng: location.lng
      }
    })
      .then(res => {
        setIsLoading(false);
        setIsOpenPromoteStore(false);
        setPromoteCodeStore(code);
        setNamePromoteCodeStore(code);
        setDiscountMoneyStore(_.get(res, "data.discountDeposit"));
        setPromoteIdStore(_.get(res, "data.id"));
        if (data != 1) {
          toastr.success(
            `Khuyến mại của cửa hàng ${inputFormat(
              (_.get(res, "data.discountDeposit") / 1000).toString()
            )}`
          );
        }
      })
      .catch(function(e) {
        setIsLoading(false);
        setPromoteCodeStore("");
        setDiscountMoneyStore(0);
        setNamePromoteCodeStore("");
        setPromoteIdStore("");
      });
    if (data != 1) {
      setIsLoading(true);
    }
  };
  const getConfigFee = () => {
    getConfigErrandFee().then(res => {
      setConfigErrandFee(res.data);
    });
  };
  const closeModal = () => {
    if (!promoteId) {
      setPromoteCode("");
    }
    setIsOpen(false);
  };

  const closeModalAddress = () => {
    setIsOpenAddress(false);
    const subname = localStorage.getItem("sub-name");
    setSubName(_.cloneDeep(subname));
  };

  const openModal = () => {
    setIsOpen(true);
  };
  const openModelPromote = () => {
    if (_.isEmpty(user)) {
      setMessagePopup("Bạn vui lòng đăng nhập để xem khuyến mại HeyU");
      openModelLogin();
    } else {
      openModal();
      getListPromote();
    }
  };
  const btnGetlistProduct = data => {
    getListProduct({
      storeId: data._id,
      productType: productType == " " ? "" : productType,
      limit
    }).then(res => {
      const obj = JSON.parse(localStorage.getItem("list-carts"));
      if (res.code == 200) {
        let dataFiller = res.data;
        for (var i = 0; i < dataFiller.length; i++) {
          dataFiller[i].quantity = 0;
        }
        if (obj == null) {
          addCart.map(data => {
            var index = _.findIndex(dataFiller, item => item._id === data._id);
            if (index !== -1) {
              dataFiller[index].quantity = data.quantity;
            }
          });
        } else {
          obj.map(data => {
            var index = _.findIndex(dataFiller, item => item._id === data._id);
            if (index !== -1) {
              dataFiller[index].quantity = data.quantity;
            }
          });
        }
        setListStore(dataFiller);
      }
    });
  };
  useEffect(() => {
    let dataStore = 10;
    dataStore = dataStore + listStore.length;
    if (dataStore == limit && infoStore) {
      btnGetlistProduct(infoStore);
    }
  }, [limit]);
  useEffect(() => {
    let listOrder = 10;
    listOrder = listOrder + listOrderUser.length;
    if (listOrder == limitOrder) {
      if (Object.values(props.user).length != 0) {
        getListForCustomer({
          status: idFiterOrder == "" ? idFiterOrder : [idFiterOrder],
          limit: limitOrder
        }).then(res => {
          if (res.code == 200) {
            setListOrderUser(res.data);
          }
        });
      }
    }
  }, [limitOrder, props.user]);
  const closeModalLogin = () => {
    setIsOpenLogin(false);
  };
  const openModelLogin = () => {
    setIsOpenLogin(true);
  };
  useEffect(() => {
    setUser(props.user);
  }, [props.user]);
  const btnSearch = value => {
    clearTimeout(delay);
    setInputSearch(value);
    if (value.length == 0) {
      setInputSearch("");
      filler(productType);
    } else {
      const obj = JSON.parse(localStorage.getItem("list-carts"));
      delay = setTimeout(function() {
        getListProduct({
          storeId: infoStore._id,
          productType: productType == " " ? "" : productType,
          name: value
        }).then(res => {
          if (res.code == 200) {
            let dataFiller = res.data;
            for (var i = 0; i < dataFiller.length; i++) {
              dataFiller[i].quantity = 0;
            }
            if (obj == null) {
              addCart.map(data => {
                var index = _.findIndex(
                  dataFiller,
                  item => item._id === data._id
                );
                if (index !== -1) {
                  dataFiller[index].quantity = data.quantity;
                }
              });
            } else {
              obj.map(data => {
                var index = _.findIndex(
                  dataFiller,
                  item => item._id === data._id
                );
                if (index !== -1) {
                  dataFiller[index].quantity = data.quantity;
                }
              });
            }
            setListStore(dataFiller);
          }
        });
      }, 300);
    }
  };
  const comeBack = () => {
    setIsLoading(true);
    getListForCustomer({
      status: idFiterOrder == "" ? idFiterOrder : [idFiterOrder],
      limit: limitOrder
    }).then(res => {
      if (res.code == 200) {
        setIsCart(3);
        setIsLoading(false);
        setListOrderUser(res.data);
        clearInterval(interval);
      }
    });
  };

  const filler = data => {
    getListProduct({
      storeId: infoStore._id,
      service: data.service,
      productType: data._id,
      limit: limitOrder
    }).then(res => {
      if (res.code == 200) {
        let dataFiller = res.data;
        for (var i = 0; i < dataFiller.length; i++) {
          dataFiller[i].quantity = 0;
        }
        addCart.map(data => {
          var index = _.findIndex(dataFiller, item => item._id === data._id);
          if (index !== -1) {
            dataFiller[index].quantity = data.quantity;
          }
        });
        setInputSearch("");
        setListStore(dataFiller);
      }
    });
  };

  const getListFilter = async data => {
    const res = await getListProductType({
      storeId: data._id
      // service: data.service,
    });
    if (res.code == 200) {
      setListFiter(res.data);
    }
  };
  const btnChecklogin = () => {
    getListPromote();
    localStorage.setItem("screen", 1);
    setIsCart(1);
    GetOrdertype();
    getCODConfig(orderType);
  };
  const getDistance = data => {
    getDistanceMoney({
      orderType: data._id,
      origin: {
        lat: infoStore.location.coordinates[1],
        lng: infoStore.location.coordinates[0]
      },
      moneyUng: billPlease(addCart) - discountMoneyStore,
      destination: [
        {
          lat: location.lat,
          lng: location.lng
        }
      ]
    })
      .then(res => {
        setDistanceMoney(_.cloneDeep(res.data));
      })
      .catch(e => setIsOpenAddress(true));
  };
  const GetOrdertype = () => {
    if (!_.isEmpty(infoStore)) {
      setIsLoading(true);
      let serviceFood = [
        "5d4cea5468731c9493253bb9",
        "5ecb8ef5e5cc236f417bae25"
      ];
      if (serviceFood.indexOf(infoStore.service) == -1) {
        btnGetOrdertype();
      } else {
        btnGetOrdertypefood(infoStore.service);
      }
    }
  };
  const btnGetOrdertype = () => {
    getOrderType({
      originPlace: {
        lat: infoStore.location.coordinates[1],
        lng: infoStore.location.coordinates[0]
      },
      destinationPlaces: [
        {
          lat: location.lat,
          long: location.lng
        }
      ],
      originName: infoStore.address,
      destinationNames: [{ name: nameAddressUser }]
    }).then(res => {
      setOrderType(res.data);
      getDistance(res.data);
      setIsLoading(false);
    });
  };
  const btnGetOrdertypefood = data => {
    getOrderTypeFood({
      originPlace: {
        lat: infoStore.location.coordinates[1],
        lng: infoStore.location.coordinates[0]
      },
      destinationPlaces: [
        {
          lat: location.lat,
          long: location.lng
        }
      ],
      originName: infoStore.address,
      service: data,
      destinationNames: [{ name: nameAddressUser }]
    })
      .then(res => {
        setOrderType(res.data);
        getDistance(res.data);
        setIsLoading(false);
      })
      .catch(e => setIsLoading(false));
  };
  useEffect(() => {
    if (Object.keys(infoStore).length != 0) {
      getCODConfig(orderType, infoStore);
    }
    setMoneyCod(calculateCODFee(billPlease(addCart), orderType, configCOD));
  }, [countDishes(addCart), infoStore]);
  useEffect(() => {
    let indexIsAvailable = -1;
    indexIsAvailable = _.findIndex(addCart, product => !product.isAvailable);
    setIsChekIsAvailable(indexIsAvailable === -1);
    if (promoteCodeStore && countDishes(addCart) != 0) {
      checkPromoteCodeStore(promoteCodeStore, 1);
    } else if (countDishes(addCart) === 0) {
      setPromoteCodeStore("");
      setDiscountMoneyStore(0);
      setNamePromoteCodeStore("");
      setPromoteIdStore("");
    }
  }, [countDishes(addCart)]);
  useEffect(() => {
    if (countDishes(addCart) != 0 && !_.isEmpty(orderType)) {
      // getDistance(orderType);
      getListPromote();
      if (namePromoteCode) {
        checkPromote(namePromoteCode);
      }
    }
  }, [billPlease(addCart) - discountMoneyStore]);
  const getCODConfig = data => {
    if (_.isEmpty(data)) {
      return;
    }
    getConfigCODOrder({
      orderType: [data._id],
      originPlace: {
        lat: infoStore.location.coordinates[1],
        lng: infoStore.location.coordinates[0]
      }
    }).then(res => {
      setConfigCOD(_.get(res, "data"));
      setMoneyCod(
        calculateCODFee(billPlease(addCart), data, _.get(res, "data"))
      );
    });
  };
  const createOder = () => {
    if (_.isEmpty(user)) {
      setMessagePopup("Bạn vui lòng đăng nhập để tạo đơn hàng");
      openModelLogin();
    } else if (Object.values(distanceMoney).length === 0) {
      GetOrdertype();
    } else if (
      user.shop &&
      user.shop.isAuthen === 0 &&
      billPlease(addCart) - discountMoneyStore > orderType.depositNotAuthen
    ) {
      toastr.warning(orderType.messageNotAuthen);
    } else {
      const listCart = [];
      addCart.forEach(item => {
        if (item.toppingSelected && item.toppingSelected.length) {
          delete item.topping;
          item.topping = item.toppingSelected;

          item.topping.map((t, idx) => {
            item.topping[idx].topping = item.topping[idx].toppingSelected;
          });
          listCart.push({
            _id: item._id,
            quantity: item.quantity,
            toppingSelected: item.topping,
            description: item.description,
            images: item.images,
            isAvailable: item.isAvailable,
            name: item.name,
            price: item.price,
            pricePromote: item.pricePromote
          });
        }else{
          listCart.push({
            _id: item._id,
            quantity: item.quantity,
            toppingSelected: [],
            description: item.description,
            images: item.images,
            isAvailable: item.isAvailable,
            name: item.name,
            price: item.price,
            pricePromote: item.pricePromote
          });
        }


      });
      const receiver = {
        name: user.name,
        phone: user.phone,
        address: {
          name: nameAddressUser,
          location: {
            lat: location.lat,
            lng: location.lng
          },
          subName: subName || ""
        }
      };
      let obj = {
        orderType: orderType._id,
        cart: listCart,
        deliveryType: "heyu",
        receiver: receiver,
        note: note,
        money: billPlease(addCart),
        tip: tip,
        paymentMethod: "cash",
        store: infoStore._id,
        salary: distanceMoney.money,
        polylines: distanceMoney.polylines,
        distance: distanceMoney.distance,
        discountMoney: discountMoney,
        CODFee: moneyCod,
        noteStore,
        platform: "web"
      };
      if (promoteId) {
        obj.promote = promoteId;
      }

      if (promoteIdStore) {
        obj.discountMoneyDeposit = discountMoneyStore;
        obj.promoteStore = promoteIdStore;
      }

      ReactSwal.fire({
        title: (
          <div className="arg-row">
            <div className="arg-col-12" style={{ fontSize: "20px" }}>
              Tạo đơn hàng mới
            </div>
            <div className="arg-col-12" style={{ marginTop: "20px" }}>
              <strong style={{ fontSize: "26px" }}>{infoStore.name}</strong>
            </div>
            <div className="arg-col-12" style={{ marginTop: "10px" }}>
              <small style={{ fontSize: "20px" }}>{infoStore.address}</small>
            </div>
            <div
              className="arg-col-12"
              style={{
                width: "100%",
                height: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px"
              }}
            >
              <Countdown duration={3} />
            </div>
          </div>
        ),
        timer: 3000,
        showDenyButton: true,
        showConfirmButton: false,
        denyButtonText: "Huỷ",
        allowOutsideClick: false
      }).then(result => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          createOrderStore(obj)
            .then(res => {
              if (res.code === 200) {
                localStorage.removeItem("list-carts");
                setAddCart([]);
                setNote("");
                setNoteStore("");
                getListProductDf();
                btnScreenOrder(res.data);
                setPromoteCode("");
                setDiscountMoney(0);
                setPromoteId("");
                setDiscountMoneyStore(0);
                setPromoteCodeStore("");
                setPromoteIdStore("");
                localStorage.setItem("screen", 3);
              }
            })
            .catch(function(e) {
              console.log(e);
            });
        }
      });
    }
  };
  const getListProductDf = async () => {
    const res = await getListProduct({
      storeId: infoStore._id,
      productType: productType == " " ? "" : productType
    });
    if (res.code == 200) {
      let dataFiller = res.data;
      for (var i = 0; i < dataFiller.length; i++) {
        dataFiller[i].quantity = 0;
      }
      setListStore(dataFiller);
    }
  };
  const onConfirm = e => {
    e.preventDefault();
    if (!promoteCode) {
      return toastr["info"]("Bạn chưa nhập mã ưu đãi, vui lòng thử lại!");
    }
    checkPromote(promoteCode, (err, result) => {
      if (result) {
        toastr.info(
          `Mã ưu đãi áp dụng thành công, bạn được giảm ${result
            .toString()
            .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")}đ vào phí ship!`
        );
        closeModal();
      }
    });
  };
  const onConfirmPromoteStore = e => {
    e.preventDefault();
    if (!promoteCodeStore) {
      return toastr["info"]("Bạn chưa nhập mã ưu đãi, vui lòng thử lại!");
    }
    checkPromoteCodeStore(promoteCodeStore, (err, result) => {
      if (result) {
        toastr.info(
          `Mã ưu đãi áp dụng thành công, bạn được giảm ${result
            .toString()
            .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")}đ vào phí ship!`
        );
        closeModalPromote();
      }
    });
  };
  const otherCode = () => {
    setIsOpen(true);
    setPromoteCode("");
    setDiscountMoney(0);
    setNamePromoteCode(0);
    setPromoteId("");
    setIsAddPromote(false);
  };
  const otherCodeStore = () => {
    setDiscountMoneyStore(0);
    setPromoteCodeStore("");
    setPromoteIdStore("");
    setNamePromoteCodeStore("");
    setIsOpenPromoteStore(true);
  };
  const handleChangePlace = place => {
    setAddressInput(place);
    if (localStorage.getItem("location") != null) {
      const dataLocation = JSON.parse(localStorage.getItem("location"));
      if (
        place.geometry.lat != dataLocation.geometry.lat &&
        place.geometry.long != dataLocation.geometry.long
      ) {
        setSubName("");
        localStorage.removeItem("sub-name");
      }
    }
  };
  const btnSubmit = () => {
    if (subName) {
      localStorage.setItem("sub-name", subName);
    } else {
      localStorage.setItem("sub-name", "");
    }
    if (Object.values(addressInput).length != 0) {
      setIsLoading(true);
      setNameAddressUser(addressInput.address);
      setLocation({
        lat: addressInput.geometry.lat,
        lng: addressInput.geometry.long
      });
      getDistanceMoney({
        orderType: orderType._id,
        origin: {
          lat: infoStore.location.coordinates[1],
          lng: infoStore.location.coordinates[0]
        },
        destination: [
          {
            lat: addressInput.geometry.lat,
            lng: addressInput.geometry.long
          }
        ]
      })
        .then(res => {
          if (res.code == 200) {
            setIsLoading(false);
            setDistanceMoney(_.cloneDeep(res.data));
            setPromoteCode("");
            setDiscountMoney(0);
            setPromoteId("");
            setNamePromoteCode("");
            setNamePromoteCodeStore("");
            setPromoteIdStore("");
            setDiscountMoneyStore(0);
            setPromoteCodeStore("");
          }
        })
        .catch(function() {
          setDistanceMoney({});
          setIsLoading(false);
        });
      const setjson = JSON.stringify(addressInput);
      localStorage.setItem("location", setjson);
      setIsOpenAddress(false);
    }
    setIsOpenAddress(false);
  };
  const btnScreenOrder = data => {
    if (Object.keys(distanceMoney).length != 0) {
      setIsLoading(true);
    }
    if (data == undefined) {
      getListForCustomer({
        status: "",
        limit: limitOrder
      }).then(res => {
        if (res.code == 200) {
          setIsCart(3);
          setIsLoading(false);
          setListOrderUser(res.data);
        }
      });
    } else {
      getListForCustomer({
        status: "",
        limit: limitOrder
      }).then(res => {
        if (res.code == 200) {
          setIsCart(3);
          setIsLoading(false);
          setIdDetailOrder(data);
          setListOrderUser(res.data);
        }
      });
    }
  };
  const btnCancelOrder = data => {
    Swal.fire({
      title: "Bạn có muốn huỷ đơn hàng này không",
      icon: "question",
      showDenyButton: true,
      confirmButtonText: "Huỷ",
      denyButtonText: "Không"
    }).then(result => {
      if (result.value) {
        rejectForCustomer({ orderId: data }).then(res => {
          if (res.code == 200) {
            setIsLoading(true);
            getForCustomer({ id: data }).then(res => {
              if (res.code == 200) {
                setIsLoading(false);
                setDetailOrder(res.data);
                setIdDetailOrder("");
                setIsCart(4);
              }
            });
            getTimeLine({ orderId: data }).then(res => {
              if (res.code == 200) {
                seTimeLine(res.data);
              }
            });
          }
        });
      } else if (result.dismiss === Swal.DismissReason.deny) {
      }
    });
  };
  useEffect(() => {
    if (Object.keys(distanceMoney).length != 0) {
      setIsLoading(true);
    }
    getListForCustomer({
      status: idFiterOrder == "" ? idFiterOrder : [idFiterOrder],
      limit: limitOrder
    }).then(res => {
      if (res.code == 200) {
        setIsLoading(false);
        setListOrderUser(res.data);
      }
    });
  }, [idFiterOrder]);
  useEffect(() => {
    if (idDetailOrder) {
      getForCustomer({ id: idDetailOrder }).then(res => {
        if (res.code == 200) {
          setIsLoading(false);
          setDetailOrder(res.data);
          setIdDetailOrder("");
          setIsCart(4);
        }
      });
      getTimeLine({ orderId: idDetailOrder }).then(res => {
        if (res.code == 200) {
          seTimeLine(res.data);
        }
      });
      clearInterval(interval);
      interval = setInterval(function() {
        getForCustomer({ id: idDetailOrder }).then(res => {
          if (res.code == 200) {
            setIsLoading(false);
            setDetailOrder(_.cloneDeep(res.data));
            setIdDetailOrder("");
            setIsCart(4);
          }
        });
        getTimeLine({ orderId: idDetailOrder }).then(res => {
          if (res.code == 200) {
            seTimeLine(_.cloneDeep(res.data));
          }
        });
      }, 10000);
    } else {
      setIsLoading(false);
    }
  }, [idDetailOrder]);
  const btnLoginScreen = () => {
    setIsLogin(true);
  };
  const screenSwitch = data => {
    localStorage.setItem("screen", data);
    if (data == 0) {
      setIsCart(0);
    } else if (data == 3) {
      setIsLoading(true);
      getListForCustomer({
        status: idFiterOrder == "" ? idFiterOrder : [idFiterOrder],
        limit: limitOrder
      })
        .then(res => {
          if (res.code == 200) {
            setIsCart(3);
            setIsLoading(false);
            setListOrderUser(res.data);
          }
        })
        .catch(function() {
          setIsCart(3);
          setIsLoading(false);
        });
    } else if (data == 2) {
      setIsCart(2);
      setUser(props.user);
    }
  };

  const openLoginIsCart = () => {
    setIsLogin(true);
    setIsOpenLogin(false);
  };

  const btnOrderHistory = async service => {
    let storeNew = await axios.post(`${PRODUCT_SERVICE}/api/v1.0/store/get`, {
      id: service.store._id
    });
    let dataStore = storeNew.data.data;
    if (service.store._id === infoStore._id) {
      if (!_.isEmpty(dataStore)) {
        const cartCode = localStorage.getItem("code-store");
        if (cartCode == null) {
          localStorage.setItem("code-store", dataStore._id.toUpperCase());
        } else {
          if (cartCode != dataStore._id.toUpperCase()) {
            localStorage.setItem("code-store", dataStore._id.toUpperCase());
            localStorage.removeItem("list-carts");
            localStorage.removeItem("screen");
          }
          let obj = JSON.parse(localStorage.getItem("list-carts"));
          if (obj != null) {
            setAddCart(_.cloneDeep(obj));
          }
        }
        setIsLoading(true);
        setDisplayStore(false);
        setIsStore(false);
        let indexIsAvailable = -1;
        if (dataStore) {
          checkOutOfStock({
            ids: service.cart.map(type => type._id),
            storeId: service.store._id
          }).then(res => {
            let cartStore = res.data;
            service.cart.map(data => {
              var index = _.findIndex(cartStore, item => item._id === data._id);
              indexIsAvailable = _.findIndex(
                cartStore,
                product => !product.isAvailable
              );
              if (index !== -1) {
                cartStore[index].quantity = data.quantity;
                if (data.toppingSelected) {
                  data.toppingSelected.map((t, idx) => {
                    data.toppingSelected[idx].toppingSelected =
                      data.toppingSelected[idx].topping;
                  });
                  cartStore[index].toppingSelected = data.toppingSelected;
                }
                cartStore[index].topping &&
                  cartStore[index].topping.map((item1, i) => {
                    cartStore[index].toppingSelected.map((item2, j) => {
                      if (item1._id == item2._id) {
                        cartStore[index].topping[i].quantity = item2.quantity;
                        cartStore[index].topping[i].toppingSelected =
                          item2.toppingSelected;
                        cartStore[index].topping[i].topping.map((item3, k) => {
                          item2.toppingSelected.map((item4, l) => {
                            if (item3._id == item4._id) {
                              cartStore[index].topping[i].topping[k].quantity =
                                item4.quantity;
                            }
                          });
                        });
                      }
                    });
                  });
              }
            });

            setIsChekIsAvailable(indexIsAvailable === -1);
            localStorage.setItem("list-carts", JSON.stringify(cartStore));

            setAddCart(_.cloneDeep(cartStore));

            setIdDetailOrder("");
            clearInterval(interval);
            setIsCart(1);
            localStorage.setItem("screen", 1);
          });
          localStorage.setItem("my-region", dataStore.region);
          setInfoStore(dataStore);
          btnGetlistProduct(dataStore);
          getListFilter(dataStore);
          setDisplayStore(true);
          setIsLoading(false);
          getConfigFee();
          getListPromote();
          getListPromoteStore(dataStore);
          getCount(dataStore);
          setPromoteCode("");
          setDiscountMoney(0);
          setPromoteId("");
          setDiscountMoneyStore(0);
          setPromoteCodeStore("");
          setPromoteIdStore("");
          getPromoteStoreConfig(dataStore);
          getCountPromoteStore(dataStore);
          const screen = localStorage.getItem("screen");
          if (screen != null) {
            setIsCart(screen);
          } else {
            setIsCart(0);
          }
        } else {
          setIsLoading(false);
          setIsStore(true);
          setDisplayStore(false);
        }
      } else {
        setDisplayStore(false);
        setIsStore(true);
        setIsLoading(false);
      }
    } else {
      let obj = JSON.parse(localStorage.getItem("list-carts"));
      let messageCart = "";
      if (!_.isEmpty(obj)) {
        messageCart =
          "Bạn đang chọn mua sản phẩm thuộc hệ thống hoặc cửa hàng khác. HeyU sẽ xóa toàn bộ giỏ hàng để tiếp tục? Bạn có chắc chắn muốn xóa không?";
      } else {
        messageCart =
          "Bạn đang chọn mua sản phẩm thuộc hệ thống hoặc cửa hàng khác. HeyU sẽ chuyển cửa hàng để bạn tiếp tục mua hàng";
      }
      Swal.fire({
        title: messageCart,
        showDenyButton: true,
        confirmButtonText: "Đồng ý",
        denyButtonText: "Không"
      }).then(result => {
        if (_.get(dataStore, "name", "") == nameStore) {
          setNameStore("");
        } else {
          setNameStore(infoStore.name);
        }

        if (result.value) {
          if (!_.isEmpty(dataStore)) {
            const cartCode = localStorage.getItem("code-store");
            if (cartCode == null) {
              localStorage.setItem("code-store", dataStore._id.toUpperCase());
            } else {
              if (cartCode != dataStore._id.toUpperCase()) {
                localStorage.setItem("code-store", dataStore._id.toUpperCase());
                localStorage.removeItem("list-carts");
                localStorage.removeItem("screen");
              }
              let obj = JSON.parse(localStorage.getItem("list-carts"));
              if (obj != null) {
                setAddCart(_.cloneDeep(obj));
              }
            }
            setIsLoading(true);
            setDisplayStore(false);
            setIsStore(false);
            let indexIsAvailable = -1;
            if (dataStore) {
              checkOutOfStock({
                ids: service.cart.map(type => type._id),
                storeId: service.store._id
              }).then(res => {
                let cartStore = res.data;
                service.cart.map(data => {
                  var index = _.findIndex(
                    cartStore,
                    item => item._id === data._id
                  );
                  indexIsAvailable = _.findIndex(
                    cartStore,
                    product => !product.isAvailable
                  );
                  if (index !== -1) {
                    cartStore[index].quantity = data.quantity;
                    if (data.toppingSelected) {
                      data.toppingSelected.map((t, idx) => {
                        data.toppingSelected[idx].toppingSelected =
                          data.toppingSelected[idx].topping;
                      });
                      cartStore[index].toppingSelected = data.toppingSelected;
                    }

                    cartStore[index].topping &&
                      cartStore[index].topping.map((item1, i) => {
                        cartStore[index].toppingSelected.map((item2, j) => {
                          if (item1._id == item2._id) {
                            cartStore[index].topping[i].quantity =
                              item2.quantity;
                            cartStore[index].topping[i].toppingSelected =
                              item2.toppingSelected;
                            cartStore[index].topping[i].topping.map(
                              (item3, k) => {
                                item2.toppingSelected.map((item4, l) => {
                                  if (item3._id == item4._id) {
                                    cartStore[index].topping[i].topping[
                                      k
                                    ].quantity = item4.quantity;
                                  }
                                });
                              }
                            );
                          }
                        });
                      });
                  }
                });
                setIsChekIsAvailable(indexIsAvailable === -1);
                localStorage.setItem("list-carts", JSON.stringify(cartStore));
                setAddCart(_.cloneDeep(cartStore));
                setIdDetailOrder("");
                clearInterval(interval);
                setIsCart(1);
                localStorage.setItem("screen", 1);
              });
              localStorage.setItem("my-region", dataStore.region);
              setInfoStore(dataStore);
              btnGetlistProduct(dataStore);
              getListFilter(dataStore);
              setDisplayStore(true);
              setIsLoading(false);
              getConfigFee();
              getListPromote();
              getListPromoteStore(dataStore);
              getCount(dataStore);
              setPromoteCode("");
              setDiscountMoney(0);
              setPromoteId("");
              setDiscountMoneyStore(0);
              setPromoteCodeStore("");
              setPromoteIdStore("");
              getPromoteStoreConfig(dataStore);
              getCountPromoteStore(dataStore);
              const screen = localStorage.getItem("screen");
              if (screen != null) {
                setIsCart(screen);
              } else {
                setIsCart(0);
              }
            } else {
              setIsLoading(false);
              setIsStore(true);
              setDisplayStore(false);
            }
          } else {
            setDisplayStore(false);
            setIsStore(true);
            setIsLoading(false);
          }
        } else if (result.dismiss === Swal.DismissReason.deny) {
        }
      });
    }
  };

  const onScrollLayout = (e) => {
    const {target} = e

    if (target && target.scrollHeight - target.offsetHeight === target.scrollTop) {
      switch (parseInt(isCart)) {
        case 0:
        if (listStore && listStore.length <= limit) {
          setLimit(limit+10)
        }
        break;
        case 3:
        if (listOrderUser && listOrderUser.length <= limitOrder) {
          setLimitOrder(limitOrder+10)
        }
        break;

        default:

      }
    }
  }

  return (
    <>
      <Loading open={isLoading}/>
      {displayStore == false ? (
        <div
          style={{
            width: "100%",
            maxWidth: "600px",
            margin: "auto",
            backgroundColor: "#f0f0f0"
          }}
        >
          {isStore == false ? (
            <div className="loading">Loading&#8230;</div>
          ) : <NoStoreFound/>}
        </div>
      ) :
      !isLogin ? (
        <>
        <Container maxWidth="sm" disableGutters={true}>
        <Box sx={{position: 'absolute', display: 'flex', flexDirection: 'column', bgcolor: '#f0f0f0', height: '100%', width: '100%', maxWidth: '600px' }}>
          <Box sx={{ flexGrow: 1, overflow: 'auto' }} onScroll={onScrollLayout}>
            {
              isCart == 0 ? (
              <Content
                infoStore={infoStore}
                listStore={listStore}
                productType={productType}
                setProductType={setProductType}
                btnSearch={btnSearch}
                listFiter={listFiter}
                filler={filler}
                setDataDetail={setDataDetail}
                grid={grid}
                setAddCart={setAddCart}
                addCart={addCart}
                dataDetail={dataDetail}
                inputSearch={inputSearch}
                setLimit={setLimit}
                limit={limit}
                nameStore={nameStore}
                orderType={orderType}
                user={user}
                discountMoneyStore={discountMoneyStore}
                setIsCart={setIsCart}
                modalIsOpenTopping={modalIsOpenTopping}
                setIsOpenTopping={setIsOpenTopping}
                isEditTopping={isEditTopping}
                setIsEditTopping={setIsEditTopping}
                indexEditTopping={indexEditTopping}
                setIndexEditTopping={setIndexEditTopping}
                isEditToppingInCart={isEditToppingInCart}
                setIsEditToppingInCart={setIsEditToppingInCart}
              />
            ) : isCart == 1 ? (
              <>
                <Cart
                  setAddCart={setAddCart}
                  addCart={addCart}
                  setIsCart={setIsCart}
                  createOder={createOder}
                  distanceMoney={distanceMoney}
                  setNote={setNote}
                  note={note}
                  listStore={listStore}
                  configErrandFee={configErrandFee}
                  setTip={setTip}
                  tip={tip}
                  openModelPromote={openModelPromote}
                  count={count}
                  discountMoney={discountMoney}
                  discountMoneyStore={discountMoneyStore}
                  orderType={orderType}
                  moneyCod={moneyCod}
                  nameAddressUser={nameAddressUser}
                  setIsOpenAddress={setIsOpenAddress}
                  promoteCode={promoteCode}
                  noteStore={noteStore}
                  setNoteStore={setNoteStore}
                  setNameAddressUser={setNameAddressUser}
                  subName={subName}
                  setSubName={setSubName}
                  configPromote={configPromote}
                  countPromoteStore={countPromoteStore}
                  openModelPromoteStore={openModelPromoteStore}
                  promoteCodeStore={promoteCodeStore}
                  user={user}
                  setIsLogin={setIsLogin}
                  openModelLogin={openModelLogin}
                  setMessagePopup={setMessagePopup}
                  isChekIsAvailable={isChekIsAvailable}
                  namePromoteCodeStore={namePromoteCodeStore}
                  namePromoteCode={namePromoteCode}
                  modalIsOpenTopping={modalIsOpenTopping}
                  setIsOpenTopping={setIsOpenTopping}
                  isEditTopping={isEditTopping}
                  setIsEditTopping={setIsEditTopping}
                  indexEditTopping={indexEditTopping}
                  setIndexEditTopping={setIndexEditTopping}
                  setDataDetail={setDataDetail}
                  isEditToppingInCart={isEditToppingInCart}
                  setIsEditToppingInCart={setIsEditToppingInCart}
                ></Cart>
                <Modal
                  isOpen={isOpen}
                  style={modalStyleBottom}
                  onRequestClose={closeModal}
                  ariaHideApp={false}
                  className="animated slideInUp"
                >
                <Box sx={style}>
                  <Box sx={{position: 'relative', marginBottom: '70px'}}>
                    <AppBar
                      position="sticky"
                      color="inherit"
                    >
                      <Toolbar sx={{minHeight: '52px'}}>
                        <IconButton
                          size="large"
                          edge="start"
                          color="inherit"
                          aria-label="menu"
                          onClick={closeModal}
                        >
                          <ArrowBackIcon fontSize="large"/>
                        </IconButton>
                        <TextTitle1 sx={{flexGrow: 1}} variant="h5" component="div">
                          Ưu đãi HeyU
                        </TextTitle1>
                      </Toolbar>
                      <Box mx={2} mb={2}>
                        <InputCustom
                          onSubmit={onConfirm}
                          icon={<ConfirmationNumberIcon fontSize="large" sx={{mb: '3px'}}/>}
                          sx={{px: 2, bgcolor: '#F5F6FA', width: '100%', boxShadow: 'none', borderRadius: '16px', display: 'flex', alignItems:'center'}}
                          placeholder="Nhập mã ưu đãi"
                          value={promoteCode}
                          onChange={e =>
                            setPromoteCode(e.target.value.toUpperCase())
                          }
                        />
                      </Box>
                    </AppBar>

                    {listPromote.length ? (
                      <Box mt={1} px={2} sx={{overflow:'auto'}}>
                      <TextHead component="div">
                        Ưu đãi có sẵn
                      </TextHead>
                      {listPromote.map(item => {
                        let used = promoteId === item._id
                        return (<PromoteItem
                            key={item._id}
                            item={item}
                            used={used}
                            onUsePromote={() => onClickCode(item)}
                            onCancelPromote={otherCode}
                          />
                        )})}
                      </Box>
                    ) : null}
                    <Box sx={{position: 'fixed', width: '100%', maxWidth: '600px', bottom: 0, zIndex: 1, bgcolor: '#ffffff', boxShadow: '0px -2px 8px rgba(92, 83, 83, 0.08)'}}>
                      <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px 16px'}}>
                      <Button onClick={onConfirm} fullWidth size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
                        Xác nhận
                      </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                </Modal>

                <Modal
                  isOpen={isOpenPromoteStore}
                  style={modalStyleBottom}
                  onRequestClose={closeModalPromote}
                  ariaHideApp={false}
                  className="animated slideInUp"
                >
                <Box sx={style}>
                  <Box sx={{position: 'relative', marginBottom: '70px'}}>
                    <AppBar
                      position="sticky"
                      color="inherit"
                    >
                      <Toolbar sx={{minHeight: '52px'}}>
                        <IconButton
                          size="large"
                          edge="start"
                          color="inherit"
                          aria-label="menu"
                          onClick={closeModalPromote}
                        >
                          <ArrowBackIcon fontSize="large"/>
                        </IconButton>
                        <TextTitle1 sx={{flexGrow: 1}} variant="h5" component="div">
                          Ưu đãi cửa hàng
                        </TextTitle1>
                      </Toolbar>
                      <Box mx={2} mb={2}>
                        <InputCustom
                          onSubmit={onConfirmPromoteStore}
                          icon={<ConfirmationNumberIcon fontSize="large" sx={{mb: '3px'}}/>}
                          sx={{px: 2, bgcolor: '#F5F6FA', width: '100%', boxShadow: 'none', borderRadius: '16px', display: 'flex', alignItems:'center'}}
                          placeholder="Nhập mã ưu đãi"
                          value={promoteCodeStore}
                          onChange={e =>
                            setPromoteCodeStore(e.target.value.toUpperCase())
                          }
                        />
                      </Box>
                    </AppBar>

                    {listPromoteStore.length ? (
                      <Box mt={1} px={2}>
                      <TextHead component="div">
                        Ưu đãi có sẵn
                      </TextHead>
                      {listPromoteStore.map(item => {
                        let used = promoteIdStore === item._id
                        return (<PromoteItem
                            key={item._id}
                            item={item}
                            used={used}
                            onUsePromote={() => onClickCodeStore(item)}
                            onCancelPromote={otherCodeStore}
                          />)})}
                      </Box>
                    ) : null}
                    <Box sx={{position: 'fixed', width: '100%', maxWidth: '600px', bottom: 0, zIndex: 1, bgcolor: '#ffffff', boxShadow: '0px -2px 8px rgba(92, 83, 83, 0.08)'}}>
                      <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px 16px'}}>
                      <Button onClick={onConfirmPromoteStore} fullWidth size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
                        Xác nhận
                      </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                </Modal>
              </>
            ) : isCart == 2 ? (
              <AccountUser
                user={user}
                btnLogout={btnLogout}
                btnLoginScreen={btnLoginScreen}
                platform={platform}
              />
            ) : isCart == 3 ? (
              <ListOrder
                listOrderUser={listOrderUser}
                setIdFiterOrder={setIdFiterOrder}
                idFiterOrder={idFiterOrder}
                setIdDetailOrder={setIdDetailOrder}
                limitOrder={limitOrder}
                setLimitOrder={setLimitOrder}
                btnOrderHistory={btnOrderHistory}
                btnCancelOrder={btnCancelOrder}
              />
            ) : isCart == 4 ? (
              <DetailOrder
                setIsCart={setIsCart}
                detailOrder={detailOrder}
                timeLine={timeLine}
                comeBack={comeBack}
                btnCancelOrder={btnCancelOrder}
                platform={platform}
                btnOrderHistory={btnOrderHistory}
                configContact={configContact}
              />
            ) : null
          }
          {
          addCart.length > 0 && (isCart == 0) && infoStore.status !== 0 && infoStore.isOpen ? (
              <Box sx={{position: 'fixed', width: '100%', maxWidth: '600px', bottom: 60, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1}}>
                <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px 16px'}}>
                  <Button onClick={() => btnChecklogin()} fullWidth size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', justifyContent: 'space-between', textTransform: 'none', bgcolor: '#1589D8'}}>
                    <Box>
                    Giỏ đồ ăn • {countDishes(addCart)} món
                    </Box>
                    <Box>
                    {moneyFormat(billPlease(addCart))}
                    </Box>
                  </Button>
                </Box>
              </Box>
            ) : null}
          </Box>
          {
            isCart == 1 || isCart == 4 ? null :
            <Box sx={{borderTop: '1px solid rgba(92, 83, 83, 0.08)', width: '100%', display: 'flex', justifyContent: 'space-between', justifyItems: 'stretch', alignItems: 'stretch', bgcolor: '#ffffff'}}>
            {
              routes.map((route, i)=><BtnMenu
                key={i}
                {...route}
                onClick={(val)=>screenSwitch(val)}
                index={isCart}
              />)
            }
            </Box>
          }

        </Box>
        </Container>
        </>
      ) : (
        <Login
          props={props}
          setIsCart={setIsCart}
          setIsLogin={setIsLogin}
          isCart={isCart}
        />
      )}

      <Modal
        isOpen={isOpenLogin}
        style={modalStyleCenter}
        onRequestClose={closeModalLogin}
        ariaHideApp={false}
      >
      <Box sx={[style, {bgcolor: '#ffffff'}]}>
        <Box sx={{position: 'relative'}}>
          <Toolbar sx={{minHeight: '52px'}}>
            <TextTitle1 sx={{flexGrow: 1, textAlign: 'center'}} variant="h5" component="div">
              Thông báo
            </TextTitle1>
          </Toolbar>
          <Box p={2}>
            <TextTitle1 sx={{textAlign: 'center'}}>{messagePopup}</TextTitle1>
          </Box>
          <Box sx={{width: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '12px 16px', bgcolor: '#ffffff'}}>
            <Button onClick={openLoginIsCart} size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
              Xác nhận
            </Button>
            <Button onClick={closeModalLogin} size="large" variant="outlined" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none'}}>
              Đóng
            </Button>
          </Box>
        </Box>
      </Box>
      </Modal>

      <Modal
        isOpen={isOpenAddress}
        style={modalStyleCenter}
        onRequestClose={closeModalAddress}
        ariaHideApp={false}
      >
      <Box sx={style}>
      <Box sx={{position: 'relative'}}>
        <AppBar
          position="sticky"
          color="inherit"
        >
          <Toolbar sx={{minHeight: '52px'}}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={closeModalAddress}
            >
              <ArrowBackIcon fontSize="large"/>
            </IconButton>
            <TextTitle1 variant="h5" component="div">
              Địa chỉ giao hàng
            </TextTitle1>

          </Toolbar>
        </AppBar>
        <Grid container p={2} spacing={2} bgcolor="#ffffff">
          <Grid item xs={12}>
          <PlaceAutoCompleteInput
            placeholder="Bạn muốn giao hàng đến đâu?"
            defaultInput={nameAddressUser}
            onChangePlace={handleChangePlace}
            isCheckLocation={true}
            isCheckChooseMap={true}
          />
          </Grid>
          <Grid item xs={12}>
          <TextField
            autoComplete="off"
            fullWidth
            label="Địa chỉ chi tiết(nếu có)"
            variant="outlined"
            value={subName||""}
            onChange={e => setSubName(e.target.value)}
            InputLabelProps={{
              sx: {
                fontSize: '1.4rem'
              }
            }}
            InputProps={{
              sx: {
                fontSize: '1.4rem'
              }
            }}
          />
          </Grid>
        </Grid>
        <Box sx={{width: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '12px 16px', bgcolor: '#ffffff'}}>
          <Button onClick={btnSubmit} size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
            Xác nhận
          </Button>
          <Button onClick={closeModalAddress} size="large" variant="outlined" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none'}}>
            Đóng
          </Button>
        </Box>
      </Box>
      </Box>
      </Modal>
    </>
  );
};
const mapStateToProps = state => state;
const mapFunctionToProps = {
  getUserInf,
  setGlobalVariable
  // getTimeLineOrder,
};

const NoStoreFound = () => {
  return <div className="middle-box text-center animated fadeInDown">
    <img
      style={{ width: "100%" }}
      src="https://media.heyu.asia/uploads/file-document/2021-10-15-75c26f14bad8a7cde01f041b7a7bb2ee.png"
    />
    <h3 className="font-bold">
      {" "}
      Xin lỗi, cửa hàng không tồn tại hoặc chưa được xét duyệt. Xin
      mời bạn tải ứng dụng HeyU để tiếp tục mua hàng
    </h3>
    {getOS() ? (
      <div className="text-center p-xs">
        <a
          href={
            getOS() === "Android"
              ? "https://play.google.com/store/apps/details?id=com.sanship.pro"
              : "https://itunes.apple.com/us/app/san-ship/id1179627110"
          }
          target="_self"
          onClick={() => {
            document.location.href = "sanshipvietnam://";
          }}
          style={{
            width: "100%",
            color: "#0070ff",
            borderRadius: "6px",
            border: "1px solid #0473CD",
            padding: "6px",
            fontSize: "26px"
          }}
        >
          TẢI ỨNG DỤNG{" "}
          <img style={{ width: "60px" }} src="image/logo-mau.png" />{" "}
        </a>
      </div>
    ) : (
      <div className="text-center">
        <a style={{ fontSize: "20px" }}>Quét mã để tải app</a>
        <br />
        <img src="/image/qrcode_heyu.png" className="img-xxl" />
      </div>
    )}
  </div>
}
export default connect(mapStateToProps, mapFunctionToProps)(PreviewStore);

const PromoteItem = ({item, used, onUsePromote, onCancelPromote}) => {
  return <Box mt={2} key={item._id}>
    <Box sx={{position: 'relative', pr: 2, mr: -2, overflow:'hidden', cursor: 'pointer'}}>
      {
        item.numberOfUses ?
        <TextBody2 className="promote-count" color="#ffffff">
         <i className="fa fa-times"/><strong>{item.numberOfUses}</strong>
        </TextBody2>: null
      }
      <Box sx={{position: 'relative', borderRadius: '16px', bgcolor: '#ffffff', p: 2}}>
      <Box onClick={onUsePromote} sx={{display: 'flex', mb: 2}}>
      {item.icon ? (
        <img
        alt="image"
        style={{width: '48px', height: '48px', borderRadius: '100%'}}
        src={item.icon}
        />
      ) : null}
      <Box sx={{flexGrow: 1, pl: 2}}>
      <TextBody>
      {item.code}
      </TextBody>
      <TextBody2 color='#929394'>
      {item.name}
      </TextBody2>
      <div
      style={{fontSize: '14px', color: '#929394'}}
      dangerouslySetInnerHTML={{
        __html: item.description.replace(
          /\n/g,
          "<br />"
        )
      }}
      ></div>
      </Box>
      </Box>
      <Divider sx={{border: '0.5px dashed #EEF0F0'}}/>
      <Box sx={{position: 'absolute', right: '-8px', bottom: '63px', width: '16px', height: '16px', borderRadius: '50%', bgcolor: '#F6F6F6'}}/>
      <Box sx={{position: 'absolute', left: '-8px', bottom: '63px', width: '16px', height: '16px', borderRadius: '50%', bgcolor: '#F6F6F6'}}/>
      <Box sx={{display: 'flex', mt: 2}}>
      <Box sx={{flexGrow: 1, display: 'flex', alignItems:'center'}}>
      </Box>
      <Box >
      <Button onClick={used ? onCancelPromote : onUsePromote } sx={{fontSize: '14px', borderRadius: '12px', bgcolor: '#ffffff', color: used ? '#E93940' : '#1589D8', border: used ? '1px solid #E93940' : '1px solid #1589D8'}}>
      {used ? 'Xóa': 'Sử dụng'}
      </Button>
      </Box>
      </Box>
      </Box>
    </Box>
  </Box>;
}
